import { render, staticRenderFns } from "./TablePlayground.vue?vue&type=template&id=63e0ba32&scoped=true&"
import script from "./TablePlayground.vue?vue&type=script&lang=js&"
export * from "./TablePlayground.vue?vue&type=script&lang=js&"
import style0 from "./TablePlayground.vue?vue&type=style&index=0&id=63e0ba32&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e0ba32",
  null
  
)

component.options.__file = "TablePlayground.vue"
export default component.exports